import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EditableGridService, SystemApiService } from "@cv-invision/core";
import { Observable } from "rxjs";

@Injectable()
export class MiMutualService extends EditableGridService {

	constructor(
		private systemApiService: SystemApiService,
		private httpClient: HttpClient
	) {
		super();
	}

    getData(params:any): Observable<any>{
        const url: string = `${this.systemApiService.api.miMutual}/orders`;
        return this.httpClient.get(url, { params });
    }

    /**
     * GET - Return details of a specific order from the second endpoint.
     */
    getOrderDetails(id: string): Observable<any> {
        return this.httpClient.get(`${this.systemApiService.api.miMutual}/order/${id}`);
    }
}
